import Loadable from 'react-loadable';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const UserDashboardPostAListingPageContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "UserDashboardPostAListingPageContainer" */
      './UserDashboardPostAListingPageContainer.dynamic'
    ),
  loading: LoadableLoadingSection,
});
